import '../../assets/wan-port.svg.mjs';
import icon__default from "../../../../assets/wan-port.svg";
"use strict";
const maxWanPortCount = {
  id: "maxWanPortCount",
  title: "maxWanPortCount.title",
  // todo add didzis if icon is okay with new change
  icon: icon__default
};
export { maxWanPortCount };
//# sourceMappingURL=maxWanPortCount.mjs.map
